// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-alert[data-v-fbdff8a0]{border-left:4px solid var(--v-info-base)!important}", ""]);
// Exports
module.exports = exports;
